import { inject, Injectable, signal, Signal } from '@angular/core';
import { Dictionary, ReadonlyRepositoryListService, Result } from '@softline/core';
import { RohstoffbilanzDetail } from '../data/detail';
import { RohstoffbilanzDetailRepository } from '../repositories/detail.repository';

@Injectable()
export class RohstoffbilanzDetailService extends ReadonlyRepositoryListService<
  RohstoffbilanzDetail,
  Result<RohstoffbilanzDetail[]>,
  Dictionary<unknown> | undefined
> {
  readonly #params = signal<Signal<Dictionary<unknown> | undefined>>(signal(undefined));

  override params: Signal<Dictionary<unknown> | undefined> = signal({});

  constructor() {
    super(inject(RohstoffbilanzDetailRepository));
  }

  protected override getItems(
    result: Result<RohstoffbilanzDetail[]> | null | undefined
  ): RohstoffbilanzDetail[] {
    return result?.result ?? [];
  }

  register(params: Signal<Dictionary<unknown> | undefined>) {
    this.#params.set(params);
  }
}
